(function($, undefined) {
	"use strict";
	
	function init() {
		$('.wizard_step3 .wizard__questions').on('submit', onFormSubmit);
		
	}
	
	function onFormSubmit(e) {
		const form = $(e.currentTarget);
		const creatorId = $('[name="locationCreatorId"]').val();
		const ids = form.find('.location-form-editable-list-item:not([data-item-id=""])').map((i, el) => el.dataset.itemId).get();

		e.preventDefault();

		if (typeof creatorId != "undefined" && creatorId.length != 0) {
			ids.push(creatorId);
		}

		$('[name="users"]').val(ids.join());

		form.get(0).submit();
	}

	$(init);
	
})(jQuery);